/** FAQ, Support, and Advertising page copy (Italian). */
export const pagesMessagesIt = {
  faq: {
    pageTitle: "Domande frequenti",
    pageSubtitle: "Trova le risposte alle domande più comuni su WasOK",
    seoTitle: "FAQ — WasOK",
    seoDescription:
      "Risposte alle domande frequenti su WasOK, la scansione dei prodotti, la privacy e le valutazioni.",
    items: [
      {
        question: "Come funziona WasOK?",
        answer:
          "WasOK ti aiuta a ricordare quali prodotti ti sono piaciuti o meno scansionando i codici a barre e salvando le tue valutazioni e note. Scansiona semplicemente il codice a barre di un prodotto, valutalo, aggiungi note e, la volta successiva che scansionerai lo stesso prodotto, vedrai subito la tua recensione precedente.",
      },
      {
        question: "I miei dati vengono archiviati nel cloud?",
        answer:
          "No! Tutti i tuoi dati vengono archiviati localmente sul tuo dispositivo. Non sincronizziamo le tue informazioni con il cloud, il che significa che la tua cronologia degli acquisti e le tue opinioni sui prodotti restano completamente private. Questo però significa anche che dovresti eseguire il backup del tuo dispositivo se vuoi conservare i tuoi dati.",
      },
      {
        question: "Ho bisogno di una connessione internet per usare WasOK?",
        answer:
          "No, WasOK funziona completamente offline. Poiché tutti i tuoi dati vengono archiviati localmente sul tuo dispositivo, puoi scansionare prodotti, aggiungere valutazioni e consultare la cronologia senza alcuna connessione internet.",
      },
      {
        question: "Posso usare WasOK per qualsiasi tipo di prodotto?",
        answer:
          "Sì! WasOK funziona con qualsiasi prodotto dotato di codice a barre. Che si tratti di cibo, cosmetici, articoli per la casa, elettronica o qualsiasi altra cosa con un codice a barre, puoi scansionarlo e salvare la tua opinione.",
      },
      {
        question: "Come scansiono un codice a barre?",
        answer:
          "Apri semplicemente l'app WasOK e tocca il pulsante di scansione. Punta la fotocamera verso il codice a barre del prodotto e l'app lo rileverà e scansionerà automaticamente. Assicurati che il codice a barre sia ben illuminato e a fuoco per ottenere i risultati migliori.",
      },
      {
        question: "Posso aggiungere foto alle mie recensioni sui prodotti?",
        answer:
          "Sì! Puoi allegare foto a qualsiasi recensione di prodotto. Questo è particolarmente utile per ricordare dettagli della confezione, elenchi degli ingredienti o qualsiasi altra informazione visiva che possa aiutarti a ricordare perché ti è piaciuto o meno un prodotto.",
      },
      {
        question: "Quali informazioni posso salvare sui prodotti?",
        answer:
          "Puoi salvare valutazioni (da 1 a 5 stelle), note testuali, foto, il prezzo pagato, dove lo hai acquistato e categorie personalizzate. Queste informazioni complete ti aiutano a prendere decisioni consapevoli mentre fai la spesa.",
      },
      {
        question: "Posso creare liste della spesa?",
        answer:
          "Sì! WasOK ti permette di creare liste della spesa a partire dai prodotti che hai già recensito. Questo rende facile ricordare quali prodotti hai amato e vuoi ricomprare.",
      },
      {
        question: "Come organizzo i miei prodotti?",
        answer:
          "Puoi organizzare i prodotti usando categorie personalizzate. Ad esempio, potresti creare categorie come «Snack», «Caffè», «Cura della pelle» o «Prodotti per la pulizia». Questo rende facile sfogliare le tue recensioni per tipo.",
      },
      {
        question: "WasOK è gratuito?",
        answer:
          "Sì, WasOK è completamente gratuito da scaricare e utilizzare. Non ci sono acquisti in-app, abbonamenti o costi nascosti. Crediamo che tutti dovrebbero avere accesso a un modo privato per ricordare le proprie preferenze sui prodotti.",
      },
      {
        question: "WasOK è accessibile?",
        answer:
          "WasOK è progettato per essere utilizzabile dal maggior numero possibile di persone. L'app include funzionalità di accessibilità come il supporto per screen reader, testo scalabile e una modalità ad alto contrasto opzionale.",
      },
      {
        question: "Cosa succede se disinstallo l'app?",
        answer:
          "Poiché tutti i dati sono archiviati localmente sul tuo dispositivo, disinstallare l'app eliminerà tutte le tue recensioni sui prodotti, le note e le liste della spesa. Assicurati di esportare i tuoi dati se vuoi conservare un backup prima di disinstallare.",
      },
      {
        question: "Posso esportare i miei dati?",
        answer:
          "Sì, WasOK ti permette di esportare i tuoi dati a scopo di backup. Puoi esportare tutte le tue recensioni in un file che puoi salvare sul tuo dispositivo o nello spazio di archiviazione cloud che preferisci.",
      },
      {
        question: "WasOK traccia la mia posizione?",
        answer:
          "No, WasOK non traccia la tua posizione. Anche se puoi inserire manualmente il nome del negozio in cui hai acquistato un prodotto, l'app non utilizza il GPS né servizi di localizzazione.",
      },
      {
        question: "Posso usare WasOK su più dispositivi?",
        answer:
          "Attualmente, WasOK non si sincronizza tra dispositivi poiché tutti i dati sono archiviati localmente. Ogni dispositivo avrà il proprio database separato di prodotti e recensioni.",
      },
      {
        question: "Cosa succede se un codice a barre non viene scansionato?",
        answer:
          "Se un codice a barre non viene scansionato, assicurati che sia ben illuminato e a fuoco. Puoi anche provare a pulire l'obiettivo della fotocamera. Se il codice a barre è danneggiato o poco chiaro, potresti riuscire a inserire manualmente il numero del codice.",
      },
    ],
    cta: {
      heading: "Hai ancora domande?",
      body: "Contatta il nostro team di supporto — saremo felici di aiutarti.",
      button: "Contatta il supporto",
    },
  },
  support: {
    pageTitle: "Supporto",
    seoTitle: "Supporto — WasOK",
    seoDescription:
      "Ottieni aiuto con WasOK: contatta il supporto, segnala bug e condividi il tuo feedback.",
    getHelp: {
      title: "Ottieni aiuto",
      body: "Siamo qui per aiutarti a sfruttare al meglio WasOK. Se stai riscontrando problemi o hai domande, abbiamo diverse risorse disponibili per assisterti.",
    },
    faq: {
      title: "Domande frequenti",
      body: "Prima di contattarci, consulta la nostra sezione FAQ, dove rispondiamo alle domande più comuni su WasOK. Troverai informazioni dettagliate su come funziona l'app, la privacy, l'archiviazione dei dati e altro ancora.",
    },
    contact: {
      title: "Contatta il supporto",
      body: "Se non riesci a trovare la risposta che cerchi, il nostro team di supporto è pronto ad aiutarti. Puoi contattarci a:",
      emailLabel: "Email:",
      responseTime: "Di solito rispondiamo entro 24-48 ore",
    },
    bugs: {
      title: "Segnalazione bug",
      body: "Hai trovato un bug? Apprezziamo il tuo aiuto per migliorare WasOK. Quando segnali un bug, includi per favore:",
      items: [
        "Una descrizione dettagliata del problema",
        "I passaggi per riprodurre il problema",
        "Il modello del tuo dispositivo e la versione di Android",
        "Screenshot o registrazioni dello schermo, se possibile",
      ],
      sendPrefix: "Invia le segnalazioni di bug a:",
    },
    featureRequests: {
      title: "Richieste di funzionalità",
      bodyBefore: "Hai un'idea per una nuova funzionalità? Ci piacerebbe sentirla! Invia i tuoi suggerimenti a",
      bodyAfter:
        ". Anche se non possiamo implementare ogni richiesta, prendiamo in attenta considerazione tutti i feedback quando pianifichiamo i futuri aggiornamenti.",
    },
    knownIssues: {
      title: "Problemi noti",
      body: "Attualmente siamo a conoscenza dei seguenti problemi e stiamo lavorando per risolverli:",
      items: [
        "Alcuni codici a barre potrebbero non essere scansionati in condizioni di scarsa illuminazione — prova a usare una torcia",
        "Le note sui prodotti molto lunghe potrebbero richiedere un momento in più per essere salvate sui dispositivi più datati",
        "Le anteprime delle immagini potrebbero apparire pixelate su schermi ad alta risoluzione",
      ],
    },
    appUpdates: {
      title: "Aggiornamenti dell'app",
      body: "Rilasciamo regolarmente aggiornamenti con nuove funzionalità, miglioramenti e correzioni di bug. Assicurati di mantenere WasOK aggiornato tramite il Google Play Store per ottenere i miglioramenti più recenti.",
    },
    community: {
      title: "Community",
      body: "Unisciti alla nostra community di utenti che stanno facendo scelte di acquisto più intelligenti con WasOK. Condividi consigli, poni domande e connettiti con altri utenti sui nostri canali social.",
    },
    emergency: {
      title: "Supporto urgente",
      body: 'Se stai riscontrando un problema critico che ti impedisce di usare l\'app, indica «URGENT» nell\'oggetto della tua email, e daremo priorità alla tua richiesta.',
    },
    cta: {
      heading: "Hai ancora bisogno di aiuto?",
      body: "Il nostro team di supporto è qui per te. Non esitare a contattarci per qualsiasi domanda o dubbio.",
      button: "Invia email al supporto",
    },
  },
  advertising: {
    pageTitle: "Pubblicità e monetizzazione",
    seoTitle: "Pubblicità — WasOK",
    seoDescription: "Come WasOK affronta la pubblicità e la monetizzazione.",
    approach: {
      title: "Il nostro approccio",
      body: "In WasOK, crediamo che le tue abitudini di acquisto e le tue opinioni sui prodotti siano private e personali. Il nostro modello di business riflette questo valore fondamentale.",
    },
    noAds: {
      title: "Nessuna pubblicità",
      body: "WasOK non mostra alcuna pubblicità. Non ti mostreremo mai annunci basati sui prodotti che scansioni, sulle valutazioni che dai o su qualsiasi altro dato che crei nell'app. La tua esperienza con WasOK è completamente priva di pubblicità.",
    },
    noDataSelling: {
      title: "Nessuna vendita di dati",
      body: "Non vendiamo, affittiamo o condividiamo i tuoi dati con inserzionisti, broker di dati o terze parti. Poiché tutti i tuoi dati sono archiviati localmente sul tuo dispositivo, non vi abbiamo nemmeno accesso noi stessi. Le tue recensioni sui prodotti, le liste della spesa e le note appartengono solo a te.",
    },
    noTracking: {
      title: "Nessun tracciamento",
      body: "WasOK non utilizza pixel di tracciamento, servizi di analisi o qualsiasi altra tecnologia che monitori il tuo comportamento o condivida informazioni con terze parti. Non tracciamo quali prodotti scansioni, in quali negozi fai acquisti o come usi l'app.",
    },
    sustainability: {
      title: "Come rimaniamo sostenibili",
      body: "Potresti chiederti come manteniamo WasOK gratuito senza pubblicità o vendita di dati. Il nostro approccio è semplice:",
      items: [
        {
          label: "Gratuito e aperto:",
          text: "WasOK è gratuito per tutti, senza livelli premium o paywall",
        },
        {
          label: "Gestione snella:",
          text: "Manteniamo bassi i nostri costi sviluppando software efficiente e attento alla privacy",
        },
        {
          label: "Donazioni facoltative:",
          text: "Gli utenti che amano WasOK possono sostenerci con donazioni volontarie",
        },
        {
          label: "Open source:",
          text: "Potremmo offrire servizi di consulenza o sviluppo personalizzato per le organizzazioni",
        },
      ],
    },
    noAffiliate: {
      title: "Nessun link di affiliazione",
      body: "WasOK non utilizza link di affiliazione né riceve commissioni dai rivenditori. Quando scansioni un prodotto, non ti reindirizziamo da nessuna parte per acquistarlo. L'app serve esclusivamente per la tua documentazione personale e per le tue decisioni.",
    },
    noPromotions: {
      title: "Nessuna promozione di prodotti",
      body: "Non accettiamo pagamenti da marchi o produttori per promuovere i loro prodotti. WasOK non ti suggerirà mai prodotti, non metterà in risalto determinati marchi né influenzerà in alcun modo le tue valutazioni. Le tue opinioni sono solo tue.",
    },
    partnerships: {
      title: "Partnership con terze parti",
      body: "WasOK non collabora con aziende di marketing, aggregatori di dati o reti pubblicitarie. Operiamo in modo indipendente e diamo priorità alla tua privacy sopra ogni altra cosa.",
    },
    future: {
      title: "Piani futuri",
      body: "Ci impegniamo a mantenere WasOK privo di pubblicità e attento alla privacy. Se in futuro dovessimo introdurre un modello di business sostenibile, ci impegniamo a:",
      items: [
        "Annunciare qualsiasi cambiamento con largo anticipo",
        "Non compromettere mai la privacy o la sicurezza dei dati",
        "Offrire sempre un modo per usare l'app senza tracciamento o pubblicità",
        "Ascoltare il feedback e le preoccupazioni degli utenti",
      ],
    },
    supporting: {
      title: "Sostenere WasOK",
      body: "Se ami WasOK e vuoi sostenere la nostra missione di una memoria della spesa attenta alla privacy, puoi:",
      items: [
        "Parlare dell'app ai tuoi amici e familiari",
        "Lasciare una recensione positiva sul Google Play Store",
        "Condividere con noi il tuo feedback e i tuoi suggerimenti",
        "Considerare di fare una donazione volontaria (quando disponibile)",
      ],
    },
    cta: {
      heading: "Domande sulle nostre politiche?",
      body: "Siamo trasparenti su come funziona WasOK. Se hai domande sul nostro approccio alla privacy, alla monetizzazione o alla sostenibilità, contattaci pure.",
      button: "Contattaci",
    },
  },
};
